module.exports = __webpack_public_path__ + "img/lt.3be66b97.gif";